import { Component, EventEmitter, OnInit } from '@angular/core';
import { DwCardBaseComponent, DwComponent, DwComponentType, DwMediaRepositoryService, DwMetaDataListCardConfigData, DwRoutingService } from '@devwareapps/devware-cap';
import { AppMetaDataItemNames, CourseEntity, CourseLessonEntity, CourseListForStudentQueryEntity, CourseModuleEntity, LessonListForStudentQueryEntity, ModuleListForStudentQueryEntity } from '../../../../../meta-data/app-meta-data.service';
import { CourseRepositoryService } from '../../../services/course-repository.service';

@DwComponent<DwMetaDataListCardConfigData>({
  name: 'Lesson Card - Home Page',
  key: 'lessonCard-homePage',
  componentType: DwComponentType.card,
  //configComponent: DwCardDefaultConfigComponent,
  isGlobal: false,
  parentItemName: AppMetaDataItemNames.CourseLesson,
  configData: {
    contentItemDefinitions: [{
      display: 'Main',
      contentItemKey: 'main'
    }]
  }
})
@Component({
  selector: 'app-lesson-card-home-page',
  templateUrl: './lesson-card-home-page.component.html',
  styleUrls: ['./lesson-card-home-page.component.scss']
})
export class LessonCardHomePageComponent implements DwCardBaseComponent<any, LessonListForStudentQueryEntity> {

  cardConfig?: any;
  data?: LessonListForStudentQueryEntity;
  resolvedContext?: any;
  cardClick: EventEmitter<any> = new EventEmitter<any>();

  imageUrl: string  = ''; //= '/assets/aviator-online/img/module-image-default.png';

  defaultImageUrl: string = '/assets/aviator-online/img/lesson-image-default.png';
  progressPercent = 0;
  imageUrls: { mainImageUrl: string; backupImageUrl: string; };
  constructor(protected dwMediaRepository: DwMediaRepositoryService,
    protected dwRoutingService: DwRoutingService,
    protected courseRepositoryService: CourseRepositoryService,
  ) { }

  setupCard() {
    this.imageUrls = this.getLessonUrl();
    this.imageUrl = this.imageUrls.mainImageUrl;
    this.defaultImageUrl = this.imageUrls.backupImageUrl;
  }


  getLessonUrl() {
    return this.courseRepositoryService.getLessonImageUrl(this.data); 
  }

  click() {
    const url = `/my-courses/view/${this.data.CourseModuleCourseId}/module/${this.data.CourseModuleId}/lesson/${this.data.CourseLessonId}`;

    this.dwRoutingService.navigateToUrl(url, null);
    //this.cardClick.emit(this.data);
  }
   
  ngOnInit(): void { 
  }
}
